// Canonical vocabulary labels → the customer's language.
//
// The enum label maps in shared's vocabulary.ts (KIT_TYPE_LABELS,
// KIT_COMPONENT_ROLE_LABELS, …) are authored in English beside the value set
// they name, and `shared` is locale-free by construction — the backend feeds and
// the seed import from it too, and neither has a `t`. This resolves each entry
// through t() KEYED ON THE VALUE with the canonical string as the defaultValue,
// exactly as localizeSchemaLabels does for a served schema: a locale that has
// caught up wins, one that has not reads the canonical English, and the
// vocabulary stays the author of the source copy.
//
// It walks the map rather than taking a hand-listed set of keys, so adding an
// option to a vocabulary constant cannot leave one label behind untranslated —
// the same reason the seed generates its enum_options from those same arrays
// (ADR-018 Decision 5).

import type { TFunction } from 'i18next';

export function localizeVocabLabels<T extends string>(
  keyPrefix: string,
  labels: Record<T, string>,
  t: TFunction
): Record<T, string> {
  const out = {} as Record<T, string>;
  for (const value of Object.keys(labels) as T[]) {
    out[value] = t(`${keyPrefix}.${value}`, { defaultValue: labels[value] });
  }
  return out;
}
